module.exports = __webpack_public_path__ + "36d234061ee92518a8245cb8b25f21e1.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@deere/cps-it.warranty-base-styles/icons/svg/accepted.svg
// module id = 70
// module chunks = 0